import Vue from "vue";
import Router from "vue-router";
 
import router from './router'
Vue.use(Router);
export default new Router({
  // mode: "history",
  routes: [

    ...router,
    
    {
      path: "*",
      redirect: {
        name: "404",
      },
    },
  ],
  scrollBehavior () {
    // return返回期望滚动到的位置的坐标
    return { x: 0, y: 0 }
  }
});
